// Yes, this is Sh*t, but the language string returned from XMP even differs from the ones from Connexys
import { AllowedLanguages } from "@/types/generic";

export const mapLocaleToLanguage = {
  [AllowedLanguages.Nl]: "DUT",
  [AllowedLanguages.En]: "ENG",
  [AllowedLanguages.Fr]: "FRE",
};
